import { dailyDairyService } from "../../../../Api/Services/DailyDariyService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { ISubmitDailyDairySlotPayload } from "../../types";

export const submitDailyDairy = createServiceAsyncThunk<
  { status: boolean; message: string }, // Response Type
  ISubmitDailyDairySlotPayload
>(
  ACTION_NAMES.SUBMIT_DAILY_DAIRY, // Action name
  (submitDairyParams) =>
    dailyDairyService.submitDailyDairySlot(submitDairyParams), // API Call
  ERROR_MESSAGES.SUBMIT_DAILY_DAIRY_FAILURE // Error Message
);

const submitDailyDairySlice = createGenericSlice<
  { status: boolean; message: string },
  ISubmitDailyDairySlotPayload
>(
  SLICE_NAMES.SUBMIT_DAILY_DAIRY_SLICE, //Slice Name
  submitDailyDairy // Async Thunk
);

// Export actions to be used in components for resetting error and details
export const {
  clearError: clearSubmitDailyDairyError,
  clearSuccessMessage: clearSubmitDailyDairySuccess,
} = submitDailyDairySlice.actions;

// Export the reducer to be included in the Redux store
export default submitDailyDairySlice.reducer;
